import React, { useCallback, useRef, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import Webcam from "react-webcam";
import toast from "react-hot-toast";

export const PhotoModal = ({
  lote,
  setTakePhoto,
  setImageUrl,
  imageUrl,
  setIsUrlValid
}) => {

  const [showPhoto, setShowPhoto] = useState(false);
  const webcamRef = useRef(null);

  const videoConstraints = {
    width: 400,
    height: 600,
    facingMode: "environment"
  };

  const capturePhoto = useCallback(async () => {
    try {
      const imageSrc = webcamRef.current.getScreenshot();
      setTakePhoto({
        url: dataURLtoFile(imageSrc, lote.lote),
        lote: lote.lote,
      });
      haveQRCode(lote.mercado, lote.logoID)
      setImageUrl(imageSrc);
    } catch {
      toast.error("Câmera não carregada... Aguarde", {
        duration: 4000,
      });
    }
  }, [webcamRef, lote, setTakePhoto]);

  const haveQRCode = async (mercado, logoId) => {
    switch (mercado) {
      case "MÉXICO":
        setIsUrlValid(true)
    }
    switch (logoId) {
      case "CO-0279":
      case "CO-1111":
      case "7402-G":
      case "7404-P":
      case "7505-P":
      case "PE-691":
        setIsUrlValid(true)
    }
  }

  const resetPhoto = () => {
    setTakePhoto(null);
    setImageUrl(null);
  };

  function dataURLtoFile(dataurl, filename) {
    const arr = dataurl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[arr.length - 1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }

  return (
    <>
      <Button onClick={() => setShowPhoto(true)} className="mx-3">
        TIRAR FOTO
      </Button>
      <Modal
        show={showPhoto}
        onHide={() => setShowPhoto(false)}
        centered
      >
        <Modal.Body
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            maxWidth: "200px", 
            margin: "0 auto",
            padding: "0.3rem",
          }}
        >
          {!imageUrl ? (
            <Webcam
              ref={webcamRef}
              audio={false}
              screenshotFormat="image/jpg"
              videoConstraints={videoConstraints}
              style={{
                width: videoConstraints.width,
                height: videoConstraints.height,
                borderRadius: "8px",
              }}
              mirrored={false}
            />
          ) : (
            <img
              src={imageUrl}
              alt="captured"
              style={{ maxWidth: "100%", height: "auto", borderRadius: "8px" }}
            />
          )}
        </Modal.Body>
        <Modal.Footer
          style={{ justifyContent: "center" }}
        >
          {!imageUrl ? (
            <Button onClick={capturePhoto}>Capturar Foto</Button>
          ) : (
            <>
              <Button onClick={resetPhoto}>Remover Foto</Button>
              <Button onClick={() => setShowPhoto(false)}>Concluir</Button>
            </>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};
